const apiKey = 'AIzaSyAOBlhWHt77rUmaMIsNYzSYfdOiE3dMHH8';
const discoveryDocs = ['https://sheets.googleapis.com/$discovery/rest?version=v4'];

// Create the script tag, set the appropriate attributes
const script = document.createElement('script');
script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAOBlhWHt77rUmaMIsNYzSYfdOiE3dMHH8&callback=initMap';
script.async = true;

const mapStyles = [
  {
    "stylers": [
      { "saturation": -100 },
      { "gamma": 1 }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [{ "visibility": "off" }]
  },
  {
    "featureType": "poi.business",
    "elementType": "labels.text",
    "stylers": [{ "visibility": "off" }]
  },
  {
    "featureType": "poi.business",
    "elementType": "labels.icon",
    "stylers": [{ "visibility": "off" }]
  },
  {
    "featureType": "poi.place_of_worship",
    "elementType": "labels.text",
    "stylers": [{ "visibility": "off" }]
  },
  {
    "featureType": "poi.place_of_worship",
    "elementType": "labels.icon",
    "stylers": [{ "visibility": "off" }]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      { "visibility": "simplified" }
    ]
  },
  {
    "featureType": "water",
    "stylers": [
      { "visibility": "on" },
      { "saturation": 50 },
      { "gamma": 0 },
      { "hue": "#50a5d1" }
    ]
  },
  {
    "featureType": "administrative.neighborhood",
    "elementType": "labels.text.fill",
    "stylers": [
      { "color": "#333333" }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text",
    "stylers": [
      { "weight": 0.5 },
      { "color": "#333333" }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "labels.icon",
    "stylers": [
      { "gamma": 1 },
      { "saturation": 50 }
    ]
  }
];

let map;
let infoWindow;
let locations;
let positions = [];
let markers = [];

// Attach your callback function to the `window` object
window.initMap = function() {
  map = new google.maps.Map(document.getElementById('location-map'), {
    // TODO: Update with real center
    center: { lat:40.7515165, lng: -73.9985111 },
    zoom: 12,
    panControl: false,
    // zoomControl: false,
    scaleControl: false,
    scrollwheel: false,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    styles: mapStyles,
  });

  infoWindow = new google.maps.InfoWindow({
    content: '',
    size: new google.maps.Size(150, 50),
  });

  gapi.load('client', fetchData);
};

const fetchData = () => {
  gapi.client.init({ apiKey, discoveryDocs }).then(() => {
    return gapi.client.sheets.spreadsheets.values.get({
      // spreadsheetId: '1M2fb2-1fo-5tDp7-aOgrZpia2nfJzOCExeCzONfM0A8',
      spreadsheetId: '1d3vEvCKPB6LhyXk7a2lA-tmw_Sii7UFtKQ9rFt65BEE',
      range: 'Sheet0!A6:I10000',
    });
  }).then(response => {
    var location =  {
      "name": "Threes Brewing",
      "address": "383 West 31st Street, New York, NY",
      "latLng": {
          "lat": 40.7515659,
          "lng": -73.9967909
      }
     };

     addMarker(location);
    new MarkerClusterer(map, markers, {
      minimumClusterSize: 3,
      styles: [
        MarkerClusterer.withDefaultStyle({
          className: 'cluster',
          fontFamily: 'DIN Next LT Pro Condensed',
          fontWeight: 600,
          textColor: 'white',
          textLineHeight: 34,
          textSize: 12,
          height: 32,
          width: 32,
        })
      ]
    });
  }, reason => {
    console.error(`Error: ${reason.result.error.message}`);
  });
}

const addAllMarkers = locations => {
  for (const location of locations) {
    if (!location.latLng) return;

    addMarker(location);
  };
}

const addMarker = location => {
  positions.push(location.latLng);

  const icon = {
    url: "//threesbrewing.com/cdn/shop/t/135/assets/pin.png?v=165908524947571859531785360505",
    size: new google.maps.Size(36, 36),
    scaledSize: new google.maps.Size(36, 36),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(18, 18),
  };
  const info = locationInfo(location);

  const marker = new google.maps.Marker({
    position: location.latLng,
    map,
    icon,
  });

  google.maps.event.addListener(
    marker,
    'click',
    (marker => {
      return () => {
        infoWindow.setContent(info);
        infoWindow.open(map, marker);
      }
    })(marker)
  );

  markers.push(marker);
}

const locationInfo = location => {
  const locationString = location.address ? getLocationString(location) : null;
  let info = `<div class="location-info">`;
  const address = processAddress(location.address);

  if (location.name) {
    if (locationString) {
      info += `<h4 class="location-info__heading"><a href="https://www.google.ca/maps/?q=${locationString}" target="_blank" rel="noopener noreferrer">${location.name}</a></h4>`;
    } else {
      info += `<h4 class="location-info__heading">${location.name}</h4>`;
    }
  }

  if (location.address) {
    info += `<div class="location-info__address">${address}</div>`;
  }

  info += '</div>';

  return info;
}

const processAddress = (address) => {
  const state = address.substring(address.lastIndexOf(',') + 1);

  if (state.trim().length === 2) {
    address = address.replace(state, '');
    return `${titleCase(address)}${state}`;
  }

  return titleCase(address);
}

const getLocationString = location => {
  let locationString = encodeURIComponent(titleCase(location.name) + ', ' + processAddress(location.address));

  return locationString;
}

const processLocations = locations => {
  return locations.map(location => {
    return processLocation(location);
  });
}

const processLocation = location => {
  // Early exit if missing name / lat / lng
  if (!location[0] || !location[7] || !location[8]) return false;

  return {
    name: location[0],
    address: `${location[1]}, ${location[2]}, ${location[3]}`,
    latLng: new google.maps.LatLng(location[7], location[8]),
  };
}

const titleCase = str => str.replace(/([^\W_]+[^\s-]*) */g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

document.head.appendChild(script);

jQuery.extend(jQuery.easing, {
  easeInOutQuad: function (x, t, b, c, d) {
    if ((t/=d/2) < 1) return c/2*t*t + b;
    return -c/2 * ((--t)*(t-2) - 1) + b;
  },
  easeInOutCubic: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t + b;
      return c/2*((t-=2)*t*t + 2) + b;
  },
})

const anchors = document.querySelectorAll('a[href^="#"]:not([href$="#"])');
anchors.forEach(anchor => {
  if (anchor.hash === '#0') return;

  anchor.addEventListener('click', e => {
    e.preventDefault();

    jQuery('html, body').animate({
      scrollTop: $(anchor.hash).offset().top
    }, 800, 'easeInOutCubic');
  });
});